import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  private baseUrl = environment.apiUrl + '/api/categoryTemplate/';
  basic: string | string[];

  constructor(private http: HttpClient) { }

  getCategoryTemplate(openId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}${openId}`, httpOptions);
  }

  getCategoryTemplates(): Observable<any> {
    return this.http.get(this.baseUrl, httpOptions);
  }
}
